var _style, _rect, _rect2, _line, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "21.2mm",
    height: "21.2mm",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    * {\n      stroke-width: 0px;\n    }\n  ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "frm_3-362",
    x: 8.1,
    y: 9.1,
    width: 43.8,
    height: 43.8,
    rx: 10,
    ry: 10,
    transform: "translate(-13.1 30.3) rotate(-45)",
    fill: "#1d1d1b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "frm_3-372",
    x: 9.7,
    y: 8.4,
    width: 40.6,
    height: 40.6,
    rx: 10,
    ry: 10,
    transform: "translate(-11.5 29.6) rotate(-45)",
    fill: "#f59e00"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 27.2,
    x2: 30,
    y2: 41.2,
    fill: "#82368c"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30,43.7c-1.4,0-2.5-1.1-2.5-2.5v-13.9c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5v13.9c0,1.4-1.1,2.5-2.5,2.5Z",
    fill: "#82368c"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 19.5,
    r: 3.9,
    fill: "#82368c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoUpIcon);
export default __webpack_public_path__ + "static/media/InfoUpIcon.956827d5c8c1e092b4ddbd4e2514d0dc.svg";
export { ForwardRef as ReactComponent };